import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "submit", "resultContainer"]

  connect() {
    if (this.element.tagName === 'FORM') {
      this.element.addEventListener('ajax:success', this.handleSuccess.bind(this))
      this.element.addEventListener('ajax:error', this.handleError.bind(this))
    }
  }

  toggleSubmitButton() {
    const file = this.inputTarget.files[0]
    
    if (!file) {
      this.submitTarget.disabled = true

      return
    }
    
    this.submitTarget.disabled = false
    this.resultContainerTarget.innerHTML = ''
  }
  
  handleSuccess(event) {
    if (!this.hasResultContainerTarget) return
    
    const [data] = event.detail
    console.log('handleSuccess', data)
    if (data.success) {
      this.resultContainerTarget.innerHTML = `<div class="alert alert-success mt-4">${data.message}</div>`
    } else {
      let errorHTML = `<div class="alert alert-danger mt-4">${data.message}<ul>`
      data.errors.forEach(error => {
        errorHTML += `<li>${error}</li>`
      })
      errorHTML += '</ul></div>'
      this.resultContainerTarget.innerHTML = errorHTML
    }

    this.inputTarget.value = ''

    requestAnimationFrame(() => {
      this.submitTarget.disabled = true
    })
  }
  
  handleError(event) {
    const [data] = event.detail
    
    if (this.hasResultContainerTarget) {
      this.resultContainerTarget.innerHTML = `<div class="alert alert-danger mt-4">${data.message}</div>`
    }
    this.toggleSubmitButton()
  }
} 